import { Colors } from "../../consts/Colors";
import FONTS from "../../consts/Fonts";
import ButtonRounded from "../global/buttons/ButtonRounded";

export default class DebriefPanel extends Phaser.GameObjects.Container {
   constructor(scene) {
      super(scene, 0, 0, []);

      this.soundManager = scene.soundManager

      this.scene = scene;
      scene.add.existing(this);

      // Ajout du fond
      let background = this.scene.add.rectangle(0, 0, 800, this.scene.height, Colors.Elmt.LightGrey).setOrigin(0);
      this.add(background);

      // Ajout de la bande
      let bande = this.scene.add.rectangle(0, 0, 80, background.height, Colors.Elmt.Blue).setOrigin(0);
      this.add(bande);

      // Ajout du titre
      let debrief = this.scene.add.text(160, 66, "DEBRIEF", {
         fontSize: '14px',
         fontFamily: FONTS.InterRegular,
         color: Colors.Text.Blue,
      }).setOrigin(0)
      this.add(debrief);

      
      let line = this.scene.add.rectangle(160, 112, 560, 1, Colors.Elmt.DarkGrey).setOrigin(0);
      this.add(line);

      // Ajout du texte
      const configText = {
         fontSize: '24px',
         fontFamily: FONTS.Inter24Medium,
         color: Colors.Text.Black
      }

      let txt = "Lorsque l’on veut vérifier la véracité d’une photo, il y a plusieurs manières de faire :"
      let text = this.scene.add.text(160, 140, txt, configText).setOrigin(0).setWordWrapWidth(560);
      this.add(text);

      let txts = [
         "Vous pouvez vous appuyer sur des éléments scientifiques pour faire une recherche : comme ici avec le nom de la fleur.",
         "Vous pouvez vous intéresser à la récurrence de la photo",
         "Vous pouvez faire une recherche de correspondance d’images afin d’identifier la source de la photo.",
         "Vous pouvez analyser les sites sur lesquels la photo apparaît : s'agit-il de sites fiables (source scientifique), ou bien de réseaux sociaux ou d’autres sites sans caution scientifique.",
         "Et enfin, vous pouvez interroger un outil de détection de contenus générés par IA comme Hive Moderation."
      ]
      let Y = text.y + text.height + 24;
      txts.forEach((txt, index) => {
         let bullet = this.scene.add.circle(200, Y + 16, 6, Colors.Elmt.Orange);
         this.add(bullet);

         let text = this.scene.add.text(240, Y, txt, configText).setOrigin(0).setWordWrapWidth(482);
         this.add(text);

         Y += text.height + 24;
      })

      txt = "C’est la combinaison de plusieurs informations/observations qui peut vous amener à émettre des doutes sur une photo."
      text = this.scene.add.text(160, Y, txt, configText).setOrigin(0).setWordWrapWidth(560);
      this.add(text);

      // Ajout du bouton de fermeture
      let closeBtn = new ButtonRounded(this.scene, background.width/2 + bande.width/2, Y + text.height + 48, {
         text: "Continuer",
         color: Colors.Elmt.Orange,
         textColor: Colors.Text.White,
         hoverColor: Colors.Elmt.Blue,
      })
      closeBtn.y += closeBtn.height/2;
      this.add(closeBtn);

      closeBtn.setClickFunction(() => {
         this.animOut(() => {
            this.scene.closeDebrief()
         })      
      })

      // Ajout image
      this.image = this.scene.add.image(-50, 467, 'Chapitre1_debrief_image').setOrigin(0.5);
      this.add(this.image);


      this.setSize(background.width, background.height);
   }

   animIn() {
      this.x = this.scene.width;
      this.image.setAlpha(0);
      this.image.setAngle(10);

      this.soundManager.playOnce('PaperSlide4')
   
      this.scene.tweens.add({
         targets: this,
         x: this.scene.width - this.width,
         duration: 500,
         ease: 'Cubic.easeInOut',
         onComplete: () => {
            // Animation complete
            this.scene.tweens.add({
               targets: this.image,
               alpha: 1,
               angle: 0,
               duration: 500,
            });
         }
       });

   }

   animOut(endFunc) {
      this.soundManager.playOnce('PaperSlide4')
      this.scene.tweens.add({
         targets: this,
         x: this.scene.width,
         duration: 500,
         ease: 'Cubic.easeInOut',
         onComplete: () => {
            // Animation complete
            if(endFunc) endFunc();
         }
       });
   }
}